/**
 * SHER-244 — compose the JSON value stored in a `medical_history_template`
 * SurveyRecord. The shape mirrors the existing `TemplatedMedicalHistoryType`
 * interface plus an optional historical-survey-name snapshot used so that
 * the PDF / read view of a historical submission keeps showing the
 * template name THAT WAS LIVE AT THE TIME OF SUBMISSION, even if the live
 * template is later renamed. See SubmissionPDFDocument.tsx (effective-
 * SurveyName useMemo) for the read side.
 */
export interface TemplatedMedicalHistoryComposedValue {
    'template_medical_history-template_id': string;
    'template_medical_history-notes': string;
    'template_medical_history-survey_name'?: string;
}

export function composeTemplatedMedicalHistoryValue(args: {
    templateId: string;
    notes: string;
    surveyName?: string;
}): TemplatedMedicalHistoryComposedValue {
    const out: TemplatedMedicalHistoryComposedValue = {
        'template_medical_history-template_id': args.templateId,
        'template_medical_history-notes': args.notes,
    };
    if (args.surveyName && args.surveyName.trim()) {
        out['template_medical_history-survey_name'] = args.surveyName;
    }
    return out;
}
